/**
 * 当前是否为本地开发环境，仅允许localhost和proxyhost的浏览器主机访问
 */
export const isLocal: boolean = ['localhost', 'proxyhost'].includes(window.location.hostname);

//产品对应图标库地址
export const gameImageOrigin: string = 'https://gdas.gux.netease.com/resources/app_logo/';

export const A_Z_Map = [
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
  'H',
  'I',
  'J',
  'K',
  'L',
  'M',
  'N',
  'O',
  'P',
  'Q',
  'R',
  'S',
  'T',
  'U',
  'V',
  'W',
  'X',
  'Y',
  'Z'
];
//星期几列表
export const WeekDays = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
//31天日期列表
export const MonthDays = Array(31)
  .fill(0)
  .map((x, index) => index);

// 延迟推送新增单位
export const DelayUnits: any = {
  2: {
    value: 2,
    text: '秒'
  },
  0: {
    value: 0,
    text: '分钟'
  }
};
//时间单位
export const Units = {
  0: {
    value: 0,
    text: '分钟'
  },
  1: {
    value: 1,
    text: '小时'
  }
};
//频率列表
export const Frequencies = {
  0: {
    value: 0,
    text: '每日'
  },
  1: {
    value: 1,
    text: '每周'
  },
  2: {
    value: 2,
    text: '每月'
  }
};

export const getPublicPath = () => {
  if (isLocal) return '';
  if (window.microAppInfo) return window.microAppInfo.entry;
  return '';
};

export const EXCEL_FILE_TYPE = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];
